import { Container, Row, Col, Alert, ListGroup, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import CartItemComponent from "../../components/CartItemComponent";

const CartPageComponent = ({
  addToCart,
  removeFromCart,
  cartItems,
  cartSubtotal,
  reduxDispatch,
}) => {
  const changeCount = (productID, count) => {
    reduxDispatch(addToCart(productID, count));
  };

  const removeFromCartHandler = (productID, quantity, price) => {
     if (window.confirm("Sei sicuro?")) {
         reduxDispatch(removeFromCart(productID, quantity, price));
     } 
  }

  return (
    <Container fluid>
      <Row className="mt-4">
        <Col md={8}>
          <h1>Carrello</h1>
          {cartItems.length === 0 ? (
            <Alert variant="info">Il tuo carrello è vuoto</Alert>
          ) : (
            <ListGroup variant="flush">
              {cartItems.map((item, idx) => (
                <CartItemComponent
                  item={item}
                  key={idx}
                  changeCount={changeCount}
                  removeFromCartHandler={removeFromCartHandler}
                />
              ))}
            </ListGroup>
          )}
        </Col>
        <Col md={4}>
          <ListGroup>
            <ListGroup.Item>
              <h3>Totale provvisorio ({cartItems.length} {cartItems.length === 1 ? "Prodotto" : "Prodotti"})</h3>
            </ListGroup.Item>
            <ListGroup.Item>
              Prezzo: <span className="fw-bold">€{cartSubtotal}</span>
            </ListGroup.Item>
            <ListGroup.Item>
              <LinkContainer to="/user/cart-details">
                <Button disabled={cartSubtotal === 0} type="button">Procedi al Checkout</Button>
              </LinkContainer>
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </Container>
  );
};

export default CartPageComponent;
